import React from 'react';

export function ContactUs(): React.JSX.Element {
  return (
    <div className="flex flex-col min-h-[50vh] p-4 max-w-3xl mx-auto">
      <h1>Contact Us</h1>
      <div className="text-medium-emphasis-font my-4 space-y-4">
        <p>
          {"We appreciate your patience if you're experiencing issues. This is an evolving "}
          application and we appreciate all the feedback you share with us.
        </p>
        <p>
            You can reach out via email at DataApps@propriovision.com.
        </p>
        {/*<p>
          You can reach out via email at DataApps@propriovision.com or fill out the following feedback form.
        </p>
        <button
          type="button"
          disabled
          className="rounded px-10 py-2 disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-80"
          style={{ border: '1px solid var(--border)', backgroundColor: 'transparent' }}
        >
          Feedback Form
        </button>*/}
      </div>
    </div>
  );
}

export default ContactUs;
